import {
  t,
  translate,
} from "components/CentralDataMangement/translation/Translation";
import Title from "components/common/atoms/Title";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";
import React from "react";
import { Link } from "react-router-dom";

const WhatsappTiles: React.FC = () => {
  const cardStyle = {
    className: "card border-0 card-shadow justify-content-center h-100",
  };

  return (
    <AccessControl
      requiredPermissions={[
        {
          permission: "Whatsapp",
          read: true,
        },
      ]}
      renderNoAccess={true}
    >
      <Title title={t("Whatsapp")} className="tab-section-title " />
      <div className="form-height-dashboard mt-2">
        <div
          className="recruiter-action-tabs"
          style={{
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "1.5vw",
            display: "grid",
          }}
        >
          <AccessControl
            requiredPermissions={[
              {
                permission: "Whatsapp",
                read: true,
              },
            ]}
          >
            <Link to="/manage/whatsapp-user" className="dashboard-tab-links">
              <div {...cardStyle}>{t("Whatsapp accounts")}</div>
            </Link>
          </AccessControl>
          <AccessControl
            requiredPermissions={[
              {
                permission: "Whatsapp instance",
                read: true,
              },
            ]}
          >
            <Link to="/manage/whatsapp-instance" className="dashboard-tab-links">
              <div {...cardStyle}>{t("Whatsapp instance")}</div>
            </Link>
          </AccessControl>
        </div>
      </div>
      <div className="row backPadding">
        <div className="col-md-6 align-self-center">
          <Link to="/dashboard" className="back-btn text-decoration-underline">
            {t("Back")}
          </Link>
        </div>
      </div>
    </AccessControl>
  );
};

export default translate(WhatsappTiles);
